import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export function TransactionSuccess() {
    const { t } = useTranslation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className='flex items-center justify-center min-h-screen bg-gray-100'>
            <div className='w-full max-w-md p-6 text-center bg-white border shadow-md rounded-xl'>
                <h1 className='mb-8 text-2xl font-bold text-yellow-800'>
                    {t('transaction.success.title')}
                </h1>
                <p className='mb-6 text-gray-700'>{t('transaction.success.message')}</p>
                <a
                    href='/'
                    className='inline-block px-4 py-2 text-yellow-800 transition bg-transparent rounded'
                >
                    {t('transaction.success.homeLink')}
                </a>
            </div>
        </div>
    )
}
export function TransactionFailed() {
    const { t } = useTranslation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div className='flex items-center justify-center min-h-screen bg-gray-100'>
            <div className='w-full max-w-md p-6 text-center bg-white border shadow-md rounded-xl'>
                <h1 className='mb-8 text-2xl font-bold text-red-600'>
                    {t('transaction.failed.title')}
                </h1>
                <p className='mb-6 text-gray-700'>{t('transaction.failed.message')}</p>
                <a
                    href='/'
                    className='inline-block px-4 py-2 text-yellow-800 transition bg-transparent rounded'
                >
                    {t('transaction.failed.homeLink')}
                </a>
            </div>
        </div>
    )
}
